export { InternalControlPage as default } from '@/components/enpages/Ir/Governance/InternalControl'
